import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Button,
  Container,
  Dropdown,
  Grid,
  Header,
  Image,
  Modal,
} from 'semantic-ui-react';

import {
  changeScreen
} from '../actions/bookPayConfirmActions';

import euro from '../images/bookingScreen/euro.svg';
import car from '../images/bookingScreen/car.svg';

class BookingScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ticketPrice: 7.8,
      parkingPrice: props.parkingPrice,
    };
  }

  setTicketPrice = newPrice => {
    this.setState({
      ticketPrice: newPrice,
    });
  }

  setParkingPrice = newPrice => {
    console.log(newPrice);
    this.setState({
      parkingPrice: newPrice,
    });
  }

  render() {
    return (
      <>
        <Modal.Content>
          <Grid container verticalAlign='middle'>
            <Grid.Row>
              <Grid.Column width='8'>
                <Grid.Row as={Grid}>
                  <Grid.Row><Grid.Column>
                    <Header as='h2'>
                      {this.props.parkingLotName}
                    </Header>
                  </Grid.Column></Grid.Row>
                  <Grid.Row><Grid.Column>
                    <Header as='h3'>
                      {this.props.parkingLotAddress}
                    </Header>
                  </Grid.Column></Grid.Row>
                </Grid.Row>

                <Grid.Row as={Grid}>
                  <Grid.Row>
                    <Grid.Column width='4'>
                      <Image src={euro} />
                    </Grid.Column>
                    <Grid.Column width='12'>
                      {this.props.parkingPrice + ' € pro Tag'}
                    </Grid.Column>
                  </Grid.Row>
                  {
                    this.props.parkingLotName.toString().includes('P+R') &&
                    <Grid.Row>
                      <Grid.Column width='4'>
                        <Image src={car} />
                      </Grid.Column>
                      <Grid.Column width='12'>
                        24h Höchstparkdauer
                    </Grid.Column>
                    </Grid.Row>
                  }
                </Grid.Row>
              </Grid.Column>

              <Grid.Column width='8' as={Grid}>
                <Grid.Row>
                  <Header as='h3' >
                    Abfahrtszeit
                  </Header>
                  <Container>
                    {this.props.departureTimes[this.props.index]}
                  </Container>

                </Grid.Row>
                <Grid.Row>
                  <Header as='h3' >
                    Parkschein
                  </Header>
                  <Dropdown fluid onChange={(e, data) => { this.setParkingPrice(data.value) }} defaultValue={this.props.parkingPrice} selection placeholder='Einzelticket' options={[
                    { key: 'einzel', value: this.props.parkingPrice, text: 'Einzelticket: ' + this.props.parkingPrice + ' €' },
                    { key: 'zehner', value: this.props.parkingPrice * 9.5, text: 'Zehnerticket: ' + this.props.parkingPrice * 9.5 + ' €' },
                    { key: 'monat', value: this.props.parkingPrice * 11, text: 'Pendlerkarte (Monat): ' + this.props.parkingPrice * 11 + ' €' },
                    { key: 'jahr', value: this.props.parkingPrice * 110, text: 'Pendlerkarte (Jahr): ' + this.props.parkingPrice * 110 + ' €' },
                  ]} />

                </Grid.Row>
                <Grid.Row>
                  <Header as='h3' >
                    ÖPNV-Fahrkarte
                  </Header>
                  <Dropdown fluid onChange={(e, data) => { this.setTicketPrice(data.value) }} defaultValue={7.8} selection placeholder='Tageskarte' options={[
                    { key: 'tag', value: 7.8, text: 'Tageskarte: ' + 7.80 + ' €' },
                    { key: 'einzel', value: 3.3, text: 'Einzelfahrkarte: ' + 3.30 + ' €' },
                    { key: 'streifen', value: 14.60, text: 'Streifenkarte: ' + 14.60 + ' €' },
                  ]} />
                </Grid.Row>
              </Grid.Column>

            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Grid verticalAlign='middle'>
            <Grid.Row>
              <Grid.Column width='3'>
                <Header as='h3'>
                  Gesamt
                </Header>
              </Grid.Column>
              <Grid.Column width='3'>
                <Header as='h2' >
                  {(this.state.ticketPrice + this.state.parkingPrice) + ' €'}
                </Header>
              </Grid.Column>
              <Grid.Column width='10' floated='right'>
                <Button
                  onClick={() => { this.props.changeScreen(1) }}
                  size='large'
                  color='black'
                  content='Jetzt buchen'
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>

        </Modal.Actions>
      </>
    );
  }
}

const mapStateToProps = state => ({
  parkingLotNames: state.posts.parkingLotNames,
  parkingPrices: state.posts.parkingPrices,
  parkingLotAddresses: state.posts.parkingLotAddresses,
  departureTimes: state.posts.departureTimes,
});

export default connect(mapStateToProps, { changeScreen })(BookingScreen)